import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../lib/api';
import { releaseFileBlobUrl } from '../lib/authFile';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      try {
        const parsed = JSON.parse(userData);
        if (parsed && typeof parsed === 'object' && parsed.id) {
          if (/kerdidi|mustapha/i.test(parsed.name || '') || /kerdidi|mustapha/i.test(parsed.username || '')) {
            parsed.name = 'ODENTIS';
            localStorage.setItem('user', JSON.stringify(parsed));
          }
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          setUser(parsed);
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } catch (e) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    const { token, user } = res.data;
    releaseFileBlobUrl();
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    return user;
  };

  const logout = () => {
    // Images patients (radios, justificatifs) gardees en mémoire : libérées à la déconnexion (poste partagé).
    releaseFileBlobUrl();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const switchCabinet = async (cabinetId) => {
    const res = await api.post('/auth/switch-cabinet', { cabinetId });
    const { token, user: newUser, cabinet } = res.data;
    releaseFileBlobUrl();
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(newUser));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(newUser);
    return { user: newUser, cabinet };
  };

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 100 }}>Chargement...</div>;

  return (
    <AuthContext.Provider value={{ user, login, logout, switchCabinet }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}